import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html'
})
export class FilterComponent implements OnInit {

  filterText: string;
  filterBoolCondition: boolean;
  filteredItems: Array<any> = [];
  @Input() settings?: IFilterSettings;
  @Input() incomingData?: any[] = [];
  @Output() filtered: EventEmitter<any[]> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    this.filterItems();
  }

  filterItems() {
    if (this.settings.textFilterPropertyName && this.settings.showBooleanFilter) {
      this.filterDataWithBoolCheck();
      return;
    }
    if (!this.settings.textFilterPropertyName && !this.settings.textFilterPropertyNames
      && this.settings.showBooleanFilter) {
      this.filterDataOnlyBoolCheck();
      return;
    }
    if (this.settings.textFilterPropertyName && !this.settings.showBooleanFilter) {
      this.filterDataOnlyText();
      return;
    }
    if (this.settings.textFilterPropertyNames && this.settings.textFilterPropertyNames.length > 0
      && this.settings.showBooleanFilter) {
      this.filterDataMultiplePropertiesWithBoolCheck();
      return;
    }
    if (this.settings.textFilterPropertyNames && this.settings.textFilterPropertyNames.length > 0
      && !this.settings.showBooleanFilter) {
      this.filterDataMultipleProperties();
    } else {
      console.log('O componente de filtro não foi configurado corretamente');
    }
  }

  filterDataOnlyText() {
    const emptyFilter = (this.incomingData && this.incomingData.length === 0) ||
      this.filterText === undefined || this.filterText.trim() === '';
    if (emptyFilter) {
      this.filteredItems = this.incomingData;
    } else {
      this.filteredItems = this.incomingData.filter((v) => {
        return (v[this.settings.textFilterPropertyName].toLowerCase().includes(this.filterText.toLowerCase()));
      });
    }
    this.emitFilteredItems();
  }

  filterDataOnlyBoolCheck() {
    if (!this.filterBoolCondition) {
      this.filteredItems = this.incomingData;
    } else {
      this.filteredItems = this.incomingData.filter((v) => {
        return v[this.settings.booleanConditionPropertyName] === this.settings.booleanTrueResult;
      });
    }
    this.emitFilteredItems();
  }

  filterDataMultipleProperties() {
    const emptyFilter = (this.incomingData && this.incomingData.length === 0) ||
      this.filterText === undefined || this.filterText.trim() === '';
    if (emptyFilter) {
      this.filteredItems = this.incomingData;
    } else {
      this.filteredItems = [];
      this.settings.textFilterPropertyNames.forEach(
        propertyName => {
          const compatibleItemsForEachProperty = (this.incomingData.filter((v) => {
              return (v[propertyName] ? v[propertyName].toString().toLowerCase()
                .includes(this.filterText.toLowerCase()) : false);
            }));
          compatibleItemsForEachProperty.forEach(
              item => {
                if (item.length < 1 || this.filteredItems.includes(item)) { return; } else { this.filteredItems.push(item); }
              }
            );
        }
      );
    }
    this.emitFilteredItems();
  }

  filterDataWithBoolCheck() {
    const emptyFilter = (this.incomingData && this.incomingData.length === 0)
      || this.filterText === undefined || this.filterText.trim() === '';
    if (emptyFilter && !this.filterBoolCondition) {
      this.filteredItems = this.incomingData;
    }
    if (emptyFilter && this.filterBoolCondition) {
      this.filteredItems = this.incomingData.filter((v) => {
        return v[this.settings.booleanConditionPropertyName] === this.settings.booleanTrueResult;
      });
    }
    if (!emptyFilter && this.filterBoolCondition) {
      this.filteredItems = this.incomingData.filter((v) => {
        return (v[this.settings.textFilterPropertyName].toLowerCase().indexOf(
          this.filterText.toLowerCase()) >= 0 && v[this.settings.booleanConditionPropertyName] === this.settings.booleanTrueResult);
      });
    }
    if (!emptyFilter && !this.filterBoolCondition) {
      this.filteredItems = this.incomingData.filter((v) => {
        return (v[this.settings.textFilterPropertyName].toLowerCase().indexOf(
          this.filterText.toLowerCase()) >= 0);
      });
    }
    this.emitFilteredItems();
  }

  emitFilteredItems() {
    this.filtered.emit(this.filteredItems);
  }

  filterDataMultiplePropertiesWithBoolCheck() {
    const emptyFilter = (this.incomingData && this.incomingData.length === 0) ||
      this.filterText === undefined || this.filterText.trim() === '';
    if (emptyFilter && !this.filterBoolCondition) {
      this.filteredItems = this.incomingData;
    }
    if (emptyFilter && this.filterBoolCondition) {
      this.filteredItems = this.incomingData.filter((v) => {
        return v[this.settings.booleanConditionPropertyName] === this.settings.booleanTrueResult;
      });
    }
    if (!emptyFilter && this.filterBoolCondition) {
      this.filteredItems = [];
      this.settings.textFilterPropertyNames.forEach(
        propertyName => {
          const compatibleItemsForEachProperty = (this.incomingData.filter((v) => {
            return (v[propertyName] ? v[propertyName].toLowerCase()
              .includes(this.filterText.toLowerCase()) &&
              v[this.settings.booleanConditionPropertyName] === this.settings.booleanTrueResult : false);
          }));
          compatibleItemsForEachProperty.forEach(
            item => {
              if (item.length < 1 || this.filteredItems.includes(item)) { return; } else { this.filteredItems.push(item); }
            }
          );
        }
      );
    }
    if (!emptyFilter && !this.filterBoolCondition) {
      this.filteredItems = [];
      this.settings.textFilterPropertyNames.forEach(
        propertyName => {
          const compatibleItemsForEachProperty = (this.incomingData.filter((v) => {
            return (v[propertyName] ? v[propertyName].toLowerCase()
              .includes(this.filterText.toLowerCase()) : false);
          }));
          compatibleItemsForEachProperty.forEach(
            item => {
              if (item.length < 1 || this.filteredItems.includes(item)) { return; } else { this.filteredItems.push(item); }
            }
          );
        }
      );
    }
    this.emitFilteredItems();
  }

}

export interface IFilterSettings {
  placeholder?: string;
  width: number;
  checkboxLabel?: string;
  inputTextSearchId?: string; // ID do campo de busca para automatização dos testes
  inputBoolSearchId?: string;
  showBooleanFilter?: boolean; // Ex: só publicados, só ativos, etc.
  textFilterPropertyName?: string; // Nome da única propriedade que será considerada no filtro
  textFilterPropertyNames?: string[]; // Array de nomes de propriedades a serem consideradas no filtro (incompatível com chkbox)
  booleanConditionPropertyName?: string; // Nome da propriedade booleana a ser considerada no filtro
  booleanTrueResult?: any; // Valor que define a propriedade booleana como verdadeira. Ex: 1, sim, true, Y, etc.
}
